
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.586 1.252A2 2 0 014 .666h4.667c.176 0 .346.07.471.195l4.667 4.667a.666.666 0 01.195.471v7.334a2 2 0 01-2 2H4a2 2 0 01-2-2V2.666a2 2 0 01.586-1.414zM4 1.999a.667.667 0 00-.667.667v10.667a.667.667 0 00.667.666h8a.667.667 0 00.667-.666V6.275L8.39 2H4z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.667.666c.368 0 .666.298.666.667v4h4a.667.667 0 110 1.333H8.667A.667.667 0 018 5.999V1.333c0-.369.298-.667.667-.667z"}})])
          )
        }
      }
    